import * as API from '@/api/index'
/* 新增项目 */
export const addProject = (params) => {
    return API.POST('/A01projectManagerController/addProject', params)
}
/* 删除项目 */
export const deleteProject = (params) => {
    return API.POST('/A01projectManagerController/deleteProject', params)
}
/* 删除项目投标信息 */
export const deleteProjectBiddingInfo = (params) => {
    return API.POST('/A01projectManagerController/deleteProjectBiddingInfo', params)
}
/* 查询项目列表 */
export const findProjectList = (params) => {
    return API.POST('/A01projectManagerController/findProjectList', params)
}

/* 查询供应商投标成功项目列表 */
export const findHitBidProjectList = (params) => {
    return API.POST('/A01projectManagerController/findHitBidProjectList', params)
}


/* 查询项目投标信息 */
export const findProjectBidInfo = (params) => {
    return API.POST('/A01projectManagerController/findProjectBidInfo', params)
}

/* 修改项目 */
export const updateProject = (params) => {
    return API.POST('/A01projectManagerController/updateProject', params)
}
/* 查询供应商列表 */
export const findSupplierList = (params) => {
    return API.POST('/A02SupplierController/findSupplierList', params, { notLoading: true })
}

/* 查询供应商投标信息列表 */
export const findSupplierInfoList = (params) => {
    return API.POST('/A02SupplierController/findSupplierInfoList', params)
}

/* 查询项目采购任务根据Code */
export const findProjectTaskByCode = (params) => {
    return API.POST('/Mh01ProjectController/findProjectTaskByCode', params, {}, true)
}

/* 查询项目编号是否已经存在*/
export const findProjectNoByCode = (params) => {
    return API.POST('/Mh01ProjectController/findProjectListByCode', params, {}, true)
}

/* 修改项目投标信息状态 */
export const updateBiddingInfoState = (params) => {
    return API.POST('/A01projectManagerController/updateBiddingInfoState', params)
}

/* 修改项目采购任务时间 */
export const updateProjectTaskTime = (params) => {
    return API.POST('/Mh01ProjectController/updateProjectTaskTime', params, {}, true)
}

/* 发送投标邀请邮件给供应商 */
export const seedEmailToSupplier = (params) => {
    return API.POST('/A03OtherManagerController/seedEmailToSupplier', params)
}
/* 查看历史标书信息 */
export const findBiddingDocument = (params) => {
    return API.POST('/A01projectManagerController/findBiddingDocument', params)
}
/* 查看项目标书信息 */
export const findProjectDocument = (params) => {
    return API.POST('/A01projectManagerController/findProjectDocument', params)
}
/* 查看供应商历史报价信息 */
export const findBiddingHis = (params) => {
    return API.POST('/A03OtherManagerController/findBiddingHis', params)
}
/* 修改中标状态 */
export const updateBiddingState = (params) => {
    return API.POST('/A01projectManagerController/updateBiddingState', params)
}
/* 上传文件 */
export const filesUpload = (params) => {
    return API.POSTFILE('/A00CommonController/filesUploadNew', params)
}

/* 查询项目下拉列表 */
export const findProjectDownList = (params) => {
    return API.POST('/Mh01ProjectController/findProjectInfoList', params, {}, true)
}